import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getIsModalShown, toggleModal } from '../../store/commonSlice'
import { Button } from '../Button/Button'

import styles from './SettingsButton.module.scss'
import gear from './gear.png'
import arrowLeft from './arrow-left.png'


function SettingsButtonBody({ isVisible, isModalShown, toggleModal }) {
    const onClickHandler = useCallback(() => {
        toggleModal()
    }, [toggleModal])

    if (!isVisible) {
        return null
    }

    return (
        <Button
            isNeedRegisterResource={false}
            src={isModalShown ? arrowLeft : gear}
            onClick={onClickHandler}
            className={styles.settingsButton}
        />
    )
}

SettingsButtonBody.propTypes = {
    isModalShown: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
}

const SettingsButton = connect(
    state => ({
        isModalShown: getIsModalShown(state),
    }),
    {
        toggleModal,
    },
)(SettingsButtonBody)

SettingsButton.propTypes = {
    isVisible: PropTypes.bool.isRequired,
}

SettingsButton.defaultProps = {
    isVisible: true,
}

export { SettingsButton }
